export const initState = () => ({
	user: null,
	source: null
});

export default initState();